export default __webpack_public_path__ + "static/media/logo.1f073d2a.png";